module.exports = __webpack_public_path__ + "static/media/signup_graphic.4e12ad0f.svg";